import React from 'react';
import { createPortal } from 'react-dom';

const CancelFlightModal = ({ pending = false, onClose, onConfirm }) => createPortal(
  <div className="flight-cancel-overlay" onMouseDown={onClose}>
    <div className="flight-cancel-modal" onMouseDown={e => e.stopPropagation()}>
      <div className="flight-cancel-header">
        <span>Cancel Flight</span>
        <button type="button" className="flight-cancel-close" onClick={onClose} disabled={pending}>×</button>
      </div>

      <div className="flight-cancel-body">
        <div className="flight-cancel-mark">!</div>
        <div>
          <p className="flight-cancel-title">Discard this flight and all entered data?</p>
          <p className="flight-cancel-copy">
            Crew, fuel, oil, security search, deicing, delays and post-flight entries for this flight will be deleted.
            Linked complaints will be kept and detached from the flight.
          </p>
        </div>
      </div>

      <div className="flight-cancel-footer">
        <button type="button" className="flight-cancel-secondary" onClick={onClose} disabled={pending}>
          Keep Flight
        </button>
        <button type="button" className="flight-cancel-danger" onClick={onConfirm} disabled={pending}>
          {pending ? 'Cancelling...' : 'Cancel Flight'}
        </button>
      </div>
    </div>
  </div>,
  document.body
);

export default CancelFlightModal;
